import * as cmMessageTypes from '../../consts/communicationLayer/cmMessageTypes';
import {makeSelectCmMessageData} from '../../state/selectors/yapEncrypted';
import {getState} from '../../state/store';
import connectivityService from '../device/connectivityService';
import fwuService from '../device/fwuService';
import cmWebSocketService from './cmClientService';

const publishInitializationEvent = (isHolder) => {
    const message = {
        request_id: null,
        token: null,
        type: cmMessageTypes.CONNECTED,
        communication_interface: getCommunicationInterface(),
        SDKcapabilities: {
            supportExtended: true,
            supportPriority: true,
            supportCancellation: true,
        },
    };

    publishMWMessage(message, isHolder);
};

const publishDisconnectEvent = (isHolder) => {
    const message = {
        request_id: null,
        token: null,
        type: cmMessageTypes.DISCONNECT,
        communication_interface: getCommunicationInterface(),
    };

    publishMWMessage(message, isHolder);
};

const publishCycleCharacteristicEvent = ({frame, request_id, token, iterationNumber}) => {
    const message = {
        token,
        request_id,
        type: cmMessageTypes.CYCLE_REQUESTS,
        communication_interface: getCommunicationInterface(),
        frames: [frame],
        data: {iteration_number: iterationNumber},
    };

    publishMWMessage(message);
};

const publishCharacteristicEvent = (data) => {
    const message = {
        request_id: null,
        token: null,
        type: cmMessageTypes.STATUS_CHARACTERISTICS,
        communication_interface: getCommunicationInterface(),
        data,
    };

    publishMWMessage(message);
};

const publishFwuPackageLoadedEvent = (request_id, token, isHolder) => {
    const message = {
        request_id,
        token,
        type: cmMessageTypes.FIRMWARE_UPDATE_PACKAGE_LOAD,
        communication_interface: getCommunicationInterface(),
        data: {success: true, cm_version: '1.9.0'},
    };

    publishMWMessage(message, isHolder);
};

const publishFwuStatusEvent = (type, request_id, token, n, isHolder) => {
    const message = {
        request_id,
        token,
        type,
        communication_interface: getCommunicationInterface(),
        data: n,
    };

    publishMWMessage(message, isHolder);
};

const publishFwuFinishEvent = () => {};

const publishFwuFinishAfterRebootEvent = () => {
    const msg = fwuService.getFwUpdateFinishAfterRebootEvent();

    if (!msg) return;

    const {cmToken, cmRequestId} = makeSelectCmMessageData()(getState());

    if (cmToken && cmRequestId) {
        const message = {
            request_id: cmRequestId,
            token: cmToken,
            type: cmMessageTypes.FIRMWARE_UPDATE_START,
            communication_interface: getCommunicationInterface(),
            data: msg,
        };

        publishMWMessage(message);
    }
};

const publishFwuErrorEvent = (params) => {
    const {eventType, errorFrame} = params;

    if (!eventType || !errorFrame) {
        publishErrorEvent(params);
        return;
    }

    const {type, request_id, token, errorCode, lastRequestFrames, lastResponseFrames, isHolder} = params;
    const message = {
        request_id,
        token,
        type,
        communication_interface: getCommunicationInterface(),
        error_details: {
            event_type: eventType,
            req: lastRequestFrames,
            resp: lastResponseFrames,
        },
        data: {
            status: {success: false},
        },
        frames: [errorFrame],
        error: errorCode,
    };

    publishMWMessage(message, isHolder);
};

const publishResponseEvent = ({type, request_id, token, isHolder, data, ...rest}) => {
    const message = {
        request_id,
        token,
        type,
        communication_interface: getCommunicationInterface(),
        ...rest,
    };

    if (data) {
        message.data = data;
    }

    publishMWMessage(message, isHolder);
};

const publishErrorEvent = ({request_id, token, errorCode, isHolder}) => {
    const message = {
        request_id,
        token,
        type: cmMessageTypes.ERROR,
        communication_interface: getCommunicationInterface(),
        error: errorCode,
    };

    publishMWMessage(message, isHolder);
};

const publishSuccessReset = ({request_id, token}) => {
    const message = {
        request_id,
        token,
        type: cmMessageTypes.RESET,
        communication_interface: getCommunicationInterface(),
        data: {success: true},
    };

    publishMWMessage(message);
};

const publishMWMessage = (message, isHolder) => {
    cmWebSocketService.publishMessage(message, isHolder);
};

const getCommunicationInterface = () => (connectivityService.isUsb() ? 'usb' : 'ble');

export default {
    publishCharacteristicEvent,
    publishCycleCharacteristicEvent,
    publishDisconnectEvent,
    publishErrorEvent,
    publishFwuErrorEvent,
    publishFwuFinishAfterRebootEvent,
    publishFwuFinishEvent,
    publishFwuPackageLoadedEvent,
    publishFwuStatusEvent,
    publishInitializationEvent,
    publishResponseEvent,
    publishSuccessReset,
};
